<div class="backgroundImage">
    <app-header login= 'yes'></app-header>
    <div class="container">
        <div class="row">
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
            </div>


            <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div class="sin-in-page-top">
                    <div class="card-wrapper">
                        <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                            <div style="min-height: 500px;">
                                <app-sub-header title="Custom Text Field"></app-sub-header>

                                <!-- <div class="header main-backgroundcolor color margin-b">
                                    <span (click)="redirect()" style="float: left;"> <i  class="fas fa-arrow-left"></i> </span>
                                   <span>                                    Custom Text Field
                                </span>
                                </div> -->
                              
                                <div formArrayName="customCategory"
                                    *ngFor="let props of form.get('customCategory')['controls']; let i = index">
                                    <div [formGroupName]="i">
                                        <!-- <div *ngIf="i>0" class="header main-backgroundcolor color text-center margin-b">
                                            Social Links {{i+1}}
                                        </div>

                                        <div  *ngIf="i !=0"  class="form-group ">
                                            <div style="text-align:right">

                                                <button title="Remove" class="btn btn-danger btn-sm cursor"
                                                    (click)="removeAddress(i)">
                                                    <i class="fas fa-trash-alt margin-r"></i>Remove</button>
                                            </div>
                                        </div>
 -->


                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group register-input">
                                                    <label class="color" for="form_name">Title</label>
                                                    <textarea class="form-control" formControlName="title" [(ngModel)]="titleText"  maxlength="256"
                                                        placeholder="Title Here (eg. Mission Statement)" rows="1"
                                                        [ngClass]="{ 'is-invalid': submitted && props.get('title').errors }">
                                                    </textarea>
                                                    <div style="text-align: right;">
                                                        <p style="margin-bottom: -1rem;" class="small color">
                                                            {{titleText?.length > 0 ? titleText?.length : 0}}/256</p>
                                                    </div>
                                                    <div *ngIf="submitted && props.get('title').errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf="props.get('title').errors.required">
                                                            {{errorMessage}}</div>
                                                    </div>


                                                </div>
                                            </div>

                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group register-input">
                                                    <label class="color" for="form_name">Description</label>
                                                    <textarea class="form-control" formControlName="description"
                                                        placeholder="Type Description here (eg. Mission Statement)"
                                                        rows="5"
                                                        [ngClass]="{ 'is-invalid': submitted && props.get('description').errors }">
                                                </textarea>
                                                    <div *ngIf="submitted && props.get('description').errors"
                                                        class="invalid-feedback">
                                                        <div *ngIf=" props.get('description').errors.required">
                                                            {{errorMessage}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <br>
                            <button type="submit" class="btn btn-lg btn-block btn-primary">Skip / Add</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>